// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wFUf","toggle":"styles_toggle__1RJUt","preview":"styles_preview__2aiUz"};